export enum Language {
  English = 'en',
  Russian = 'ru',
}

export const LANG_STORAGE_KEY = 'lng-w2d';
export const LANGUAGES: Language[] = Object.values(Language);
